import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitStatus('success');
      setTimeout(() => setSubmitStatus('idle'), 3000);
      return;
    }
    try {
      await fetch('https://form.readdy.ai/api/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email, form_name: 'newsletter-subscription' }).toString(),
      });
      setSubmitStatus('success');
      setEmail('');
      setTimeout(() => setSubmitStatus('idle'), 3000);
    } catch {
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus('idle'), 3000);
    }
  };

  const displayedCategories = categories.slice(0, 4);
  const links1 = categories.slice(0, 4);
  const links2 = [
    { name: '关于我们', path: '/about' },
    { name: '联系我们', path: '/about' },
    { name: '隐私政策', path: '/about' },
    { name: '用户协议', path: '/about' },
  ];
  const links3 = [
    { name: '最新爆料', path: '/category/dushijubao' },
    { name: '黑料实锤', path: '/category/heiliaotian' },
    { name: '网红翻车', path: '/category/wanghong-black' },
    { name: '明星八卦', path: '/category/star-gossip' },
  ];

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 mb-12">
            <div className="lg:w-[30%]">
              <h4 className="text-2xl font-heading font-black text-primary-400 mb-3">
                <Link to="/" className="cursor-pointer">每日吃瓜</Link>
              </h4>
              <p className="text-sm text-foreground-300 leading-relaxed">
                每日爆料与每日黑料实时更新平台，汇聚今日大瓜独家速报、
                网红翻车实锤与明星八卦。免费吃瓜官网入口，每日更新不打烊，
                吃瓜群众必备聚集地。
              </p>
            </div>

            <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
              <div>
                <h5 className="text-sm font-semibold text-background-50 mb-4">热门分类</h5>
                <ul className="flex flex-col gap-2.5">
                  {links1.map((cat) => (
                    <li key={cat.id}>
                      <Link
                        to={`/category/${cat.slug}`}
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {cat.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h5 className="text-sm font-semibold text-background-50 mb-4">网站导航</h5>
                <ul className="flex flex-col gap-2.5">
                  {links2.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h5 className="text-sm font-semibold text-background-50 mb-4">推荐阅读</h5>
                <ul className="flex flex-col gap-2.5">
                  {links3.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 pt-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-6 mb-8">
              <div>
                <p className="text-xs text-foreground-400">
                  &copy; {new Date().getFullYear()} 每日吃瓜 版权所有 All Rights Reserved.
                </p>
              </div>
              <div className="flex items-center gap-5">
                <a href="https://weibo.com" target="_blank" rel="nofollow noopener" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  微博
                </a>
                <a href="https://www.zhihu.com" target="_blank" rel="nofollow noopener" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  知乎
                </a>
                <a href="https://www.douyin.com" target="_blank" rel="nofollow noopener" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  抖音
                </a>
                <a href="https://www.xiaohongshu.com" target="_blank" rel="nofollow noopener" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  小红书
                </a>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <p className="text-xs text-foreground-400 whitespace-nowrap">订阅每日吃瓜快报：</p>
              <form
                onSubmit={handleSubscribe}
                className="flex items-center gap-2 w-full sm:w-auto"
              >
                <input
                  className="form-protection-field"
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入你的邮箱地址"
                  required
                  className="flex-1 sm:w-64 px-4 py-2.5 bg-foreground-900 border border-foreground-700 rounded-md text-sm text-background-50 placeholder:text-foreground-400 outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {submitStatus === 'success' ? '已订阅 ✓' : submitStatus === 'error' ? '重试' : '订阅'}
                  <i className="ri-arrow-right-line ml-1.5" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}